module.exports = __webpack_public_path__ + "img/imgXharra-11.764be7ba.png";